import { render, staticRenderFns } from "./FilesTable.vue?vue&type=template&id=9a8a2c76"
import script from "./FilesTable.vue?vue&type=script&lang=js"
export * from "./FilesTable.vue?vue&type=script&lang=js"
import style0 from "./FilesTable.vue?vue&type=style&index=0&id=9a8a2c76&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports